import { Button } from "@/components/ui/button";
import { MessageCircle, Sparkles, Shield, Download } from "lucide-react";
import logoVyra from "@/assets/logo-vyra.png";
import AppPreview from "@/components/landing/AppPreview";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const scrollToSignup = () => {
    const signupSection = document.getElementById('signup');
    signupSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 py-12 bg-gradient-to-b from-background via-background to-muted/30">
      <div className="max-w-6xl mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-center lg:text-left space-y-8">
            {/* Logo */}
            <div className="flex justify-center lg:justify-start mb-8 animate-fade-in">
              <img 
                src={logoVyra} 
                alt="VYRA" 
                className="h-20 md:h-24 opacity-90"
                onError={(e) => {
                  console.error('[Hero] Erro ao carregar logo');
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>

            {/* Main Heading */}
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground">
                Seu cérebro funciona diferente.
                <br />
                <span className="text-primary">A VYRA também.</span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Feita para quem tem TDAH e mente criativa. 
                Capture pensamentos, organize ideias, aja sem pressão.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center pt-4">
              <Button 
                size="lg" 
                className="shadow-[var(--shadow-soft)] w-full sm:w-auto"
                onClick={scrollToSignup}
              >
                <Sparkles className="mr-2" />
                Experimentar grátis
              </Button>
              <Button 
                variant="gentle" 
                size="lg"
                className="w-full sm:w-auto"
                onClick={() => navigate('/login')}
              >
                <MessageCircle className="mr-2" />
                Fazer login
              </Button>
            </div>

            {/* PWA Install Link */}
            <div className="flex justify-center lg:justify-start pt-2">
              <button
                onClick={() => navigate('/install')}
                className="group inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <Download className="w-4 h-4 group-hover:animate-bounce" />
                <span>Instalar como app no seu dispositivo</span>
              </button>
            </div>
          </div>

          {/* Right Column - App Preview */}
          <div className="hidden lg:block">
            <AppPreview />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
